var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
const AnchorTypes = {
  icon: 0,
  hotspot: 1,
  useElement: 2,
  custom: 3
};
const AnchorIconTypes = {
  icon: 0,
  text: 1
};
const TriggerTypes = {
  hover: 0,
  click: 1
};
const TextSelectorTypes = {
  unused: 0,
  contains: 1,
  regex: 2
};
const AlignmentTypes = {
  elementBounds: 0,
  textNodeBounds: 1
};
const AlignmentValues = {
  top: 0,
  center: 1,
  bottom: 2,
  left: 0,
  right: 2
};
const PositioningStrategies = {
  relativeAdjacent: 0,
  relativeInternal: 1,
  embeddedAdjacent: 2,
  embeddedInternal: 3
};
const PointerPositions = {
  auto: 0,
  top: 1,
  bottom: 2,
  left: 3,
  right: 4
};
const TooltipStyles = {
  plain: 0,
  video: 1
};
let Tooltip = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('string'), _dec5 = attr('number'), _dec6 = attr('string', {
  defaultValue: () => 'tooltip'
}), _dec7 = attr('string', {
  defaultValue: () => '#222222'
}), _dec8 = attr('string'), _dec9 = attr('number'), _dec10 = attr('number'), _dec11 = attr('number'), _dec12 = attr('number'), _dec13 = attr('number'), _dec14 = attr('number'), _dec15 = attr('number'), _dec16 = attr('number'), _dec17 = attr('number'), _dec18 = attr('string'), _dec19 = attr('number'), _dec20 = attr(), _dec21 = attr(), (_class = class Tooltip extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "cssSelector", _descriptor, this);
    _initializerDefineProperty(this, "textSelector", _descriptor2, this);
    _initializerDefineProperty(this, "anchorType", _descriptor3, this);
    _initializerDefineProperty(this, "anchorText", _descriptor4, this);
    _initializerDefineProperty(this, "anchorIconType", _descriptor5, this);
    _initializerDefineProperty(this, "anchorIcon", _descriptor6, this);
    _initializerDefineProperty(this, "anchorColor", _descriptor7, this);
    _initializerDefineProperty(this, "anchorFontColor", _descriptor8, this);
    _initializerDefineProperty(this, "textSelectorType", _descriptor9, this);
    _initializerDefineProperty(this, "triggerType", _descriptor10, this);
    _initializerDefineProperty(this, "alignTo", _descriptor11, this);
    _initializerDefineProperty(this, "horizontalAlignment", _descriptor12, this);
    _initializerDefineProperty(this, "verticalAlignment", _descriptor13, this);
    _initializerDefineProperty(this, "offsetX", _descriptor14, this);
    _initializerDefineProperty(this, "offsetY", _descriptor15, this);
    _initializerDefineProperty(this, "positioningStrategy", _descriptor16, this);
    _initializerDefineProperty(this, "pointerPosition", _descriptor17, this);
    _initializerDefineProperty(this, "buildUrl", _descriptor18, this);
    _initializerDefineProperty(this, "style", _descriptor19, this);
    _initializerDefineProperty(this, "blocks", _descriptor20, this);
    _initializerDefineProperty(this, "urlPredicateGroup", _descriptor21, this);
  }
  get hasContent() {
    return this.blocks.some(block => {
      if (['code', 'paragraph'].includes(block.type)) {
        return !!block.text.trim();
      } else if (block.type === 'image') {
        return !!block.url;
      } else if (['unorderedList', 'orderedList'].includes(block.type)) {
        return block.items?.some(items => !!items.trim());
      } else if (['video', 'videoFile'].includes(block.type)) {
        return true;
      }
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cssSelector", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "textSelector", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "anchorType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "anchorText", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "anchorIconType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "anchorIcon", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "anchorColor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "anchorFontColor", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "textSelectorType", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "triggerType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "alignTo", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "horizontalAlignment", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "verticalAlignment", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "offsetX", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "offsetY", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "positioningStrategy", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "pointerPosition", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "buildUrl", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "style", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "blocks", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "urlPredicateGroup", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { Tooltip as default };
export { AnchorTypes, AnchorIconTypes, TriggerTypes, TextSelectorTypes, AlignmentTypes, AlignmentValues, PositioningStrategies, TooltipStyles, PointerPositions };